const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sortBy: "",
    filterBy: false,
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setSort: (state, action) => {
            state.sortBy = action.payload
        },
        setIsSaved: (state, action) => {
        state.filterBy = action.payload
        }
    },
});

export default filterSlice.reducer;
export const { setSort, setIsSaved} = filterSlice.actions;